var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderCardDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58203 11.2497C1.58203 6.60128 5.3503 2.83301 9.9987 2.83301C14.6471 2.83301 18.4154 6.60128 18.4154 11.2497C18.4154 13.576 17.4724 15.6811 15.946 17.2053H4.0514C2.52496 15.6811 1.58203 13.576 1.58203 11.2497Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.08301H9.7106C8.52713 7.08301 7.57028 8.11745 7.87338 9.26144C8.87674 13.0484 11.6207 14.2671 18.3333 14.583",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderCardDelivery);
export default __webpack_public_path__ + "static/media/iconOrderCardDelivery.040fc4d3d0ec5e7ccb2c1bf3a5e80161.svg";
export { ForwardRef as ReactComponent };